import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@mui/styles/makeStyles';
import { Card, Grid } from '@mui/material';
import { ANALYTICS_CARD_BORDER, ANALYTICS_CARD_SHADOW, ANALYTICS_SURFACE } from '../analyticsColors';

const useStyles = makeStyles(() => ({
  filterButton: {
    maxWidth: '180px',
    maxHeight: '50px',
    position: 'sticky',
    top: '100px',
  },
  card: {
    border: `1px solid ${ANALYTICS_CARD_BORDER}`,
    borderRadius: '10px',
    boxShadow: ANALYTICS_CARD_SHADOW,
    background: ANALYTICS_SURFACE,
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '420px',
    overflow: 'visible',
  },
  cardInner: {
    minHeight: '420px',
    height: '420px',
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
  },
  gridItem: {
    position: 'relative',
    width: '100%',
    display: 'flex',
  },
}));

function ChartContainer({ children, large, exportMeta }, ref) {
  const classes = useStyles();
  const gridClassName = classes.gridItem;
  const cardClassName = classes.card;
  const exportAttrs = exportMeta
    ? {
        'data-export-card': 'chart',
        'data-export-title': exportMeta.title || '',
        'data-export-sub-title': exportMeta.subTitle || '',
        'data-export-category': exportMeta.category || '',
        'data-export-query-key': exportMeta.queryKey || '',
        'data-export-chart-type': exportMeta.chartType || '',
      }
    : {};

  return (
    <Grid item lg={large ? 12 : 4} sm={large ? 12 : 6} className={gridClassName} {...exportAttrs}>
      <Card className={cardClassName}>
        <div ref={ref} className={classes.cardInner}>
          {children}
        </div>
      </Card>
    </Grid>
  );
}

const ForwardedChartContainer = forwardRef(ChartContainer);

const chartContainerPropTypes = {
  children: PropTypes.node,
  large: PropTypes.bool,
  exportMeta: PropTypes.shape({
    title: PropTypes.string,
    subTitle: PropTypes.string,
    category: PropTypes.string,
    queryKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    chartType: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
};

ChartContainer.propTypes = chartContainerPropTypes;
ForwardedChartContainer.propTypes = chartContainerPropTypes;

export default ForwardedChartContainer;
